<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <TableInspect
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="false"
        :isNote="true"
        table-header-title="점검사항"
        table-header-yes="양호"
        table-header-no="미흡"
        table-header-na="해당없음"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import FileUploader from '@/components/FileUploader'
import TableInspectEp from '@/components/TableInspectCustomEp'
import TableInspect from "@/components/TableInspect";

export default {
  components: {
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          ['[공통]동청사 안전점검표']: 1
        })

        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: '',

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
      },
    };
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '건축분야',
          check: false,
          title: '건축분야',
          list: [
            {
              id: 1,
              label: "피난시설규정 등 건축법상 저촉여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "기둥, 보 등 주요 구조부 손상균열 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "지반침하에 등에 따른 구조물의 위험여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "철골구조물의 구조내력 저하여부",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "옥상물탱크 물건 적치 등 과하중 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "담장, 축대 등 부대시설의 안전성 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 7,
              label: "건축물 주변 및 옥상 등의 배수시설 상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 2,
          label: '전기분야',
          check: false,
          title: '전기분야',
          list: [
            {
              id: 1,
              label: "누전차단기 등 전기시설의 정상작동 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "조명탑 등 전기시설물의 유지관리상태",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "전선 배선불량 및 문어발식 콘센트 사용여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "전기기구 접지 및 피뢰침설치 적정여부",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "전기실 등 누유, 누전 및 보호시설 적정여부",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "승강기 등 안전관리 및 작동상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 3,
          label: '가스분야',
          check: false,
          title: '가스분야',
          list: [
            {
              id: 1,
              label: "가스용기 관리실태 및 가연성 물질 방치여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "가스차단기, 경보기 등 정상작동 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "가스기기 이용실태 및 시설기준 적정여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "가스보일러의 흡·배기구시설 설치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "지하실 환기 및 관리상태 확인",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "가스밸브 노후여부, 배관매설, 고정상태",
              is_checked: "",
              note: ''
            },
            {
              id: 7,
              label: "가스사용 시 주의사항 등 안전표어 부착여부",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 4,
          label: '기계분야',
          check: false,
          title: '기계분야',
          list: [
            {
              id: 1,
              label: "배관의 파손ㆍ누수 및 유지관리상태",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "보일러, 공조시설 및 설비배관 부식여부",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "지하설비 누수, 환기상태 및 배출기 작동여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "급수ㆍ급탕ㆍ공조시설 관리 및 안전성",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "오ㆍ폐수처리시설 가동상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 5,
          label: '소방분야',
          check: false,
          title: '소방분야',
          list: [
            {
              id: 1,
              label: "내부마감재 방염기준 등의 적법여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "소화기ㆍ화재탐지기 등 소방시설 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "위험물질 및 화기관리의 적정성 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "방화문, 방화샷터의 정상작동상태 점검",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "피난ㆍ소화통로 확보여부, 유지관리 상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 6,
          label: '유지관리분야',
          check: false,
          title: '유지관리분야',
          list: [
            {
              id: 1,
              label: "비상연락망 등 재난관리체계 구축여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "안전사고 예방에 대한 직원교육 등",
              is_checked: "",
              note: ''
            },
          ],
        },

      ]
    }
  },
};
</script>

<style scoped lang="scss">
</style>
